import { defineStore } from "pinia";
import { ref } from "vue";

export const useUiStore = defineStore("ui", () => {

  const menu = ref(false);

  return { menu };
});
